import { OrderProductModel } from "@/api/order/model";
import { ImageURLUitls } from "@akc/foundation";
import { Image } from "antd-mobile";
import React from "react";
import styles from "./index.module.less";
type Props = {
  product?: OrderProductModel;
  onSnapshotClick?: () => void;
};
//交易快照-商品卡片组件
const ProductCardComp: React.FC<Props> = prop => {
  const product = prop.product;
  const skuStr = product?.productPropertyDescList?.join(" ");

  const LabelVO = () => {
    const labels = (product as any)?.labelLocationVOList;
    // H5_OrderDetail_ProductTitleFont,Mini_Program_OrderDetail_ProductTitleFont
    const tag = labels.find(e => e.locationCode.includes("_OrderDetail_ProductTitleFont"));
    if (tag && tag?.labelInfoVOList?.length) {
      const { labelInfoVOList } = tag;
      return <>{labelInfoVOList.map((e, i) => {
        const height = 16;
        const width = e.labelIconWidth / (e.labelIconHeight / height);
        return <Image className={styles.label} key={i} src={e.labelIconUrl} style={{ height, width, marginRight: 3 }} />;
      })}</>;
    }
    return null;
  };

  return (
    <div className={styles.container}>
      <Image
        className={styles.img}
        src={ImageURLUitls.normalProcessImage(product?.picUrl, 86, 86)}
        fit="contain"
      />
      <div className={styles.right}>
        <div className={styles.fir}>
          <div className={styles.title}>
            <LabelVO />
            <span>{product?.productTitle}</span>
          </div>
          <div className={styles.price}>
            <span className={styles.symbol}>¥</span>
            {product?.productAmount}
          </div>
        </div>
        <div className={styles.sec}>
          <div className={styles.sku}>{skuStr}</div>
          <div className={styles.sale}>x{product?.integrateQuantity}</div>
        </div>
        {product?.isFreeGift !== 1 && (<div className={styles.btn} onClick={prop.onSnapshotClick}>
          交易快照
        </div>)}
      </div>
    </div>
  );
};
export default ProductCardComp;
